import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {GetAnalysis, GetAnalysisVariables} from 'analysis-tool/graphql/__generated/GetAnalysis';
import {GET_ANALYSIS_QUERY} from 'analysis-tool/graphql/GetAnalysis';
import {AnalysisTemplateGraphQL} from 'analysis-tool/templates/AnalysisTemplateTypes';
import {
  GetAnalysisTemplate,
  GetAnalysisTemplateVariables,
} from 'analysis-tool/templates/graphql/__generated/GetAnalysisTemplate';
import {GET_ANALYSIS_TEMPLATE_QUERY} from 'analysis-tool/templates/graphql/GetAnalysisTemplate';
import {PipelineType} from 'pipelines/PipelineTypes';

import {GetAnalysisModifiedAt} from './__generated/GetAnalysisModifiedAt';
import {GetAnalysisTemplateModifiedAt} from './__generated/GetAnalysisTemplateModifiedAt';
import {
  GET_ANALYSIS_MODIFIED_AT_QUERY,
  GET_ANALYSIS_TEMPLATE_MODIFIED_AT_QUERY,
} from './GetModifiedAtQueries';

/** @package */
export interface PipelineQueryVariables {
  [PipelineType.ANALYSIS]: GetAnalysisVariables;
  [PipelineType.ANALYSIS_TEMPLATE]: GetAnalysisTemplateVariables;
}

/** @package */
export interface PipelineModifiedAtQuery {
  [PipelineType.ANALYSIS]: GetAnalysisModifiedAt;
  [PipelineType.ANALYSIS_TEMPLATE]: GetAnalysisTemplateModifiedAt;
}

/** @package */
export interface PipelineQueryResult {
  [PipelineType.ANALYSIS]: GetAnalysis;
  [PipelineType.ANALYSIS_TEMPLATE]: GetAnalysisTemplate;
}

/** @package */
export interface PipelineQueryData {
  [PipelineType.ANALYSIS]: AnalysisGraphQL;
  [PipelineType.ANALYSIS_TEMPLATE]: AnalysisTemplateGraphQL;
}

/** @package */
export const PIPELINE_TYPE_TO_QUERY = {
  [PipelineType.ANALYSIS]: GET_ANALYSIS_QUERY,
  [PipelineType.ANALYSIS_TEMPLATE]: GET_ANALYSIS_TEMPLATE_QUERY,
};

/** @package */
export const PIPELINE_TYPE_TO_MODIFIED_AT_QUERY = {
  [PipelineType.ANALYSIS]: GET_ANALYSIS_MODIFIED_AT_QUERY,
  [PipelineType.ANALYSIS_TEMPLATE]: GET_ANALYSIS_TEMPLATE_MODIFIED_AT_QUERY,
};

/** @package */
export const GET_PIPELINE_QUERY_DATA_BY_PIPELINE_TYPE: {
  [K in PipelineType]: (queryResult: PipelineQueryResult[K]) => PipelineQueryData[K];
} = {
  [PipelineType.ANALYSIS]: (queryResult: GetAnalysis) =>
    queryResult.analysis as PipelineQueryData[PipelineType.ANALYSIS],
  [PipelineType.ANALYSIS_TEMPLATE]: (queryResult: GetAnalysisTemplate) =>
    queryResult.analysisTemplate as PipelineQueryData[PipelineType.ANALYSIS_TEMPLATE],
};

/** @package */
export const GET_PIPELINE_MODIFIED_AT_QUERY_DATA_BY_PIPELINE_TYPE: {
  [K in PipelineType]: (
    queryResult: PipelineModifiedAtQuery[K]
  ) => {__typename: string; modifiedAt: string} | {__typename: 'InaccessibleInfoNode'};
} = {
  [PipelineType.ANALYSIS]: (queryResult: GetAnalysisModifiedAt) => queryResult.analysis,
  [PipelineType.ANALYSIS_TEMPLATE]: (queryResult: GetAnalysisTemplateModifiedAt) =>
    queryResult.analysisTemplate,
};

/** @package */
export const GET_PIPELINE_QUERY_VARIABLES_BY_PIPELINE_TYPE: {
  [K in PipelineType]: (pipelineId: string) => PipelineQueryVariables[K];
} = {
  [PipelineType.ANALYSIS]: (pipelineId: string) => ({analysisId: pipelineId}),
  [PipelineType.ANALYSIS_TEMPLATE]: (pipelineId: string) => ({analysisTemplateId: pipelineId}),
};
